import { ChangeDetectionStrategy, Component, Signal, computed, inject, input, output } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { AppConfig } from 'client/app/app.config';

/** Confirmation strip for already-uploaded photos. See client/components/quiz/CLAUDE.md. */
@Component({
  selector: 'app-quiz-photo-uploaded-strip',
  templateUrl: './quiz-photo-uploaded-strip.html',
  standalone: true,
  imports: [CsIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizPhotoUploadedStripComponent {
  private readonly appConfig = inject(AppConfig);

  readonly photoUrls = input<string[]>([]);
  readonly checkupType = input<string>('');
  /** Only the single-photo strip is tappable; the toast is a passive confirmation. */
  readonly opened = output<void>();

  readonly checkIcon: string = 'circle_tick_filled';

  readonly isSinglePhoto: Signal<boolean> = computed(() => this.photoUrls().length === 1);

  readonly label: Signal<string> = computed(() => (this.isSinglePhoto()
    ? this.uploadedLabels[this.checkupType()] ?? ''
    : $localize`:@@bothPhotosUploaded:Both photos uploaded`));

  private get uploadedLabels(): Record<string, string> {
    return {
      [this.appConfig.Shared.InstantCheckup.Type.HAIR_TOP]: $localize`:@@topPhotoUploaded:Top photo uploaded`,
      [this.appConfig.Shared.InstantCheckup.Type.HAIR_FRONT]: $localize`:@@frontPhotoUploaded:Front photo uploaded`,
    };
  }

  onOpen(): void {
    this.opened.emit();
  }
}
